import { computed, makeObservable } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';
import { MarketingRouteStore, MarketingSection } from '@servicetitan/marketing-global-route';
import { StandaloneRootStore } from '@servicetitan/standalone-root';

import { AppStore } from '../../common/stores/app.store';
import { Routes } from '../../common/enums/routes';

export const mapEnvToMfeTag = new Map<string, string>([
    ['dev', 'stage'],
    ['next', 'stage'],
]);

@injectable()
export class AutopilotCampaignsStore {
    basename = this.routeStore.getPathnameWithStandaloneRoot(
        MarketingSection.Apps,
        Routes.AutopilotCampaigns,
    );

    @computed get source() {
        return `https://unpkg.servicetitan.com/@servicetitan/marketing-autopilot-onboarding@${
            mapEnvToMfeTag.get(this.standaloneRootStore.appSettings.environmentTag) ??
            this.standaloneRootStore.appSettings.environmentTag
        }`;
    }

    @computed get data() {
        return {
            ...this.appStore.defaultMFEData,
            marketingHostRoute: '/',
            campaignsSaveRoute: '/',
            campaignsSkipRoute: '/',
        };
    }

    constructor(
        @inject(AppStore) private readonly appStore: AppStore,
        @inject(StandaloneRootStore) private readonly standaloneRootStore: StandaloneRootStore,
        @inject(MarketingRouteStore) private readonly routeStore: MarketingRouteStore,
    ) {
        makeObservable(this);
    }
}
